import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LoadingService } from "@coso/loading";
import { Observable } from "rxjs";
import { IConfigurationHolder, ISecurityRoleInfo, RoleFilterMode } from "../../../models/auto-generated";
import { SecurityRolesService } from "../../../services/security-roles.service";
import { SettingsStore } from "../../../stores/settings.store";
import { handleError } from "../../../utils/handle-error";

@Component({
  standalone:false,
  templateUrl: "./security-role-filter.component.html",
  styleUrls: ["./security-role-filter.component.scss"]
})
export class SecurityRoleFilterComponent implements OnInit {
  RoleFilterMode = RoleFilterMode;
  settings$: Observable<IConfigurationHolder>;
  readonly$: Observable<boolean>;
  errorMessage: string;
  securityRoles: ISecurityRoleInfo[];
  instanceId: string;
  constructor(public loadingService: LoadingService, private settingsStore: SettingsStore, private rolesService: SecurityRolesService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.instanceId = this.route.parent.snapshot.paramMap.get("instance-id");
    this.settings$ = this.settingsStore.settings$;
    this.readonly$ = this.settingsStore.isReadOnly$;
    this.loadSecurityRoleFilterSettings();
  }

  inputChecked(current: IConfigurationHolder, role: ISecurityRoleInfo) {
    return current.roleFilterConfiguration.roles.findIndex((r) => r.name === role.name) > -1;
  }

  inputChanged(current: IConfigurationHolder, role: ISecurityRoleInfo) {
    const index = current.roleFilterConfiguration.roles.findIndex((x) => x.name === role.name);
    if (index > -1) {
      current.roleFilterConfiguration.roles.splice(index, 1);
    } else {
      current.roleFilterConfiguration.roles.push(role);
    }
    this.updateSettings(current);
  }

  updateSettings(current: IConfigurationHolder) {
    this.settingsStore.updateSettings(current);
  }

  private loadSecurityRoleFilterSettings() {
    this.loadingService.start("Loading security role filter settings", "loadSecurityRoleFilter");
    this.rolesService.get(this.instanceId).subscribe(
      (roles) => {
        this.securityRoles = roles;
        this.loadingService.stop("loadSecurityRoleFilter");
      },
      (error) => {
        this.errorMessage = `Something went wrong due to: ${handleError(error)}`;
        this.loadingService.stop("loadSecurityRoleFilter");
      }
    );
  }
}
